// @flow

import React from 'react';
import noResultsImg from 'img/icons/search-no-results.svg';
import { jobs as t  } from 'helpers/translation';
import { links } from 'core/config/index';

type Props = {
  isCurrentUser: boolean,
  toggleVisibility: Function,
  showInput: boolean
};

export default ({ isCurrentUser, toggleVisibility, showInput }: Props) => {
  const handleClick = () => {
    if (!showInput) {
      toggleVisibility('input');
    } else window.scrollTo({ left: 0, top: 0 });
  };

  return(
    <div className="card no-results">
      <img className="no-results__img" src={noResultsImg} alt=""/>
      <p className="no-results__info">{t.no_results.primary_text}</p>
      <p className="no-results__secondary">{t.no_results.secondary_text}</p>
      {
        isCurrentUser
          ? <button type="button" className="btn btn_primary" onClick={() => handleClick()}>
            + {t.btn.add_job_alert}
          </button>
          : <a href={links.login} className="btn btn_primary">+ {t.btn.add_job_alert}</a>
      }
    </div>
  );
};
